export default "__VITE_ASSET__BBzHpiW2__"